import { useAuth } from "@/components/Auth";
import { LoadingOverlay } from "@mantine/core";
import { useEffect } from "react";
import { Navigate, useParams } from "react-router";

const VerifySMS = () => {
    const { code } = useParams();
    const {verifySMS,currentUser} = useAuth();
    useEffect(() => {
        if(code){
            verifySMS({code: code as string});
        }
    }, [code])
    useEffect(() => {
        document.title = "Verifying Phone Number - Guard Dog Real Estate Protection Service";
    }, []); 
    return (
        <>
            <LoadingOverlay visible={true} overlayProps={{blur: 2, radius: 'sm'}} loaderProps={{size: 'xl'}}></LoadingOverlay>
            {currentUser ? <Navigate to="/dashboard"  replace/> : null}
        </>
    )
}
export default VerifySMS;